/// <amd-module name="SuiteCommerce.GridOrder.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.View", ["require", "exports", "Backbone", "jQuery", "Backbone.CollectionView", "SuiteCommerce.GridOrder.Row.View", "SuiteCommerce.GridOrder.Footer.View", "SuiteCommerce.GridOrder.Summary.View", "SuiteCommerce.GridOrder.Instrumentation", "SuiteCommerce.GridOrder.Confirmation.View", "grid_order.tpl", "SuiteCommerce.GridOrder.Configuration", "SuiteCommerce.GridOrder.Cell.View"], function (require, exports, Backbone_1, jQuery, BackboneCollectionView, GridOrder_Row_View_1, GridOrder_Footer_View_1, GridOrder_Summary_View_1, Instrumentation_1, GridOrder_Confirmation_View_1, gridOrderTemplate, GridOrder_Configuration_1, GridOrder_Cell_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GridOrderView = /** @class */ (function (_super) {
        __extends(GridOrderView, _super);
        function GridOrderView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = gridOrderTemplate;
            _this.events = {
                'click [data-action="grid-order-add-to-cart-button"]': 'addLinesToCart'
            };
            _this.container = options.container;
            _this.cart = _this.container.getComponent('Cart');
            return _this;
        }
        Object.defineProperty(GridOrderView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'GridOrder.HeaderCells.Collection': function () {
                        var headerCells = _this.model.headerCollection;
                        if (headerCells.length > 0) {
                            return new BackboneCollectionView({
                                childView: GridOrder_Cell_View_1.CellView,
                                collection: headerCells,
                                childViewOptions: {
                                    container: _this.container,
                                },
                            });
                        }
                        return;
                    },
                    'GridOrder.Rows.Collection': function () {
                        return new BackboneCollectionView({
                            childView: GridOrder_Row_View_1.RowView,
                            collection: _this.model.rowsCollection,
                            childViewOptions: {
                                container: _this.container,
                            },
                        });
                    },
                    'GridOrder.Footer': function () {
                        var matrixDimensions = _this.model.getMatrixDimensions().length;
                        if (matrixDimensions >= 1) {
                            var gridOrderFooterView_1 = new GridOrder_Footer_View_1.FooterView({
                                quantitiesByColumn: _this.model.getQuantitySummaryForAnyMatrixDimension(),
                                container: _this.container,
                            });
                            _this.model.on('change', function () {
                                gridOrderFooterView_1.updateQuantities(_this.model.getQuantitySummaryForAnyMatrixDimension());
                                gridOrderFooterView_1.render();
                            });
                            return gridOrderFooterView_1;
                        }
                    },
                    'Grid.Order.Summary': function () {
                        var quantityTotal = _this.model.getQuantityTotal();
                        var subtotal = _this.model.getSubtotal();
                        var quantitiesAreValid = _this.model.quantitiesAreValid();
                        var gridOrderSummaryView = new GridOrder_Summary_View_1.SummaryView({
                            quantityTotal: quantityTotal,
                            subtotal: subtotal,
                            quantitiesAreValid: quantitiesAreValid,
                        });
                        _this.model.on('change', function () {
                            var quantityTotal = _this.model.getQuantityTotal();
                            var subtotal = _this.model.getSubtotal();
                            var quantitiesAreValid = _this.model.quantitiesAreValid();
                            gridOrderSummaryView.updateSummary(quantityTotal);
                            gridOrderSummaryView.updateSubtotal(subtotal);
                            gridOrderSummaryView.updateQuantitiesStatus(quantitiesAreValid);
                            gridOrderSummaryView.render();
                        });
                        return gridOrderSummaryView;
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        GridOrderView.prototype.addLinesToCart = function () {
            var _this = this;
            var lines = this.model.rowsCollection.getLinesForCart();
            if (lines.length > 0) {
                var addItemsToCartRequestLog_1 = Instrumentation_1.default.getLog('addItemsToCartRequestLog');
                addItemsToCartRequestLog_1.startTimer();
                jQuery('[data-action="grid-order-add-to-cart-button"]').attr('disabled', 'disabled');
                this.cart.addLines({ lines: lines }).then(function () {
                    var layout = _this.container.getComponent('Layout');
                    var quantityTotal = _this.model.getQuantityTotal();
                    var confirmationView = new GridOrder_Confirmation_View_1.ConfirmationView({
                        quantityTotal: quantityTotal,
                    });
                    // Clear input fields quantities
                    _this.model.clearQuantities();
                    // Re-render grid order
                    _this.render();
                    // Show confirmation modal
                    layout.showContent(confirmationView, {
                        showInModal: true,
                        options: { classname: 'site-modal' },
                    });
                    addItemsToCartRequestLog_1.endTimer();
                    addItemsToCartRequestLog_1.setParameters({
                        activity: 'Time it takes to add certain quantity of items to cart',
                        totalTime: addItemsToCartRequestLog_1.getElapsedTimeForTimer(),
                        quantity: lines.length,
                    });
                    addItemsToCartRequestLog_1.submit();
                });
            }
        };
        GridOrderView.prototype.getContext = function () {
            return {
                gridOrderTitle: GridOrder_Configuration_1.GridOrderConfiguration.title,
            };
        };
        return GridOrderView;
    }(Backbone_1.View));
    exports.GridOrderView = GridOrderView;
});
